module.exports = __webpack_public_path__ + "img/base_activites_peche.55fd7b88.svg";